export default __webpack_public_path__ + "static/hero_tablet-b0cbd3f7fbe37eddde624a6595cc4144.webp";